export function SuperscriptIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M2 7a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM16.768 10.36A1 1 0 0015 11v6a1 1 0 102 0v-3.238l3.232 3.878A1 1 0 0022 17v-6a1 1 0 10-2 0v3.238l-3.232-3.878z"
      ></path>
    </svg>
  );
}
